import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default class GuaranteeSlider {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {

        this.$view.slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 5,
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 930,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.5
                    }
                }

            ]
        });

    }

}